export default "__VITE_ASSET__891f6738__"